import { render, staticRenderFns } from "./grantDialog.vue?vue&type=template&id=559915f2&scoped=true"
import script from "./grantDialog.vue?vue&type=script&lang=js"
export * from "./grantDialog.vue?vue&type=script&lang=js"
import style0 from "./grantDialog.vue?vue&type=style&index=0&id=559915f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559915f2",
  null
  
)

export default component.exports